$(document).ready(function() {
// Start of $(document).ready ---------------------------
	'use strict';
	
	var zipSearch = $('.comp-zip-search');
	
	if ( zipSearch.length > 0 ) {
		zipSearchFunc();
	}
	
	function zipSearchFunc() {
		//"DISCLAIMER" CLOSE BUTTON
		$('.comp-zip-search button[data="close"]').click(function() {
			$(this).parent().slideUp(400);
		});

		//SUBMIT BUTTON DISABLED
		function checkInput() {
			if ( ($('.comp-zip-search input:radio:checked').length <= 0) && ($('.comp-zip-search input#ZipCode').val() === '') ) {
				$('.comp-zip-search input.button').prop('disabled', true);
			} else {
				$('.comp-zip-search input.button').prop('disabled', false);
			}
		}

		checkInput();
		$('.comp-zip-search input').on('keyup', checkInput);
		$('.comp-zip-search input').change(checkInput);
	}

// End of $(document).ready -----------------------------
});